import { render, staticRenderFns } from "./telepresence.vue?vue&type=template&id=2059a9fb"
import script from "./telepresence.vue?vue&type=script&lang=js"
export * from "./telepresence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports